import { render, staticRenderFns } from "./MainPropertyTablePanel.vue?vue&type=template&id=22e63886"
import script from "./MainPropertyTablePanel.vue?vue&type=script&lang=js"
export * from "./MainPropertyTablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports